import React, { useCallback } from 'react';
import './index.scss';
import { getTrans } from '@/utils/tools';
import { Copywriting } from '@/utils/constants';
import { useTripleClick } from '@/utils/hooks/useMultiClick';
import AgentStore from '@/stores/agent';
import InitStore from '@/stores/init';
import { inject, observer } from 'mobx-react';
import { getChildInject } from '@/utils/instantLoaded/tools';
import reporter from '@/utils/report';

type AgentEnterProps = {
  name?: string;
} & {
  agentStore: typeof AgentStore;
  initStore: typeof InitStore;
};


export default inject(getChildInject('agentStore', 'initStore'))(observer((props: AgentEnterProps) => {
  const {
    agentStore: {
      inAgent,
      connection,
    },
    initStore,
  } = props;

  const cb = useCallback(
    () => {
      console.log('useTripleClick');
      console.log('inAgent: ', inAgent, connection);
      if (inAgent) {
        // 结束聊天
        reporter.apiLog('end chat', { level: 'debug' });
        connection.close({ msg: 'close by avatar click' });
      }
    },
    [inAgent, connection],
  );

  const [refCallback] = useTripleClick(cb);

  const { name = '' } = props;
  return (
    <div className="agent-enter-wrapper" ref={refCallback}>
      <img className="agent-enter-avatar" src={initStore.agentAvatar || ''} />
      <div className="agent-enter-tips">{`${name} ${getTrans(Copywriting.AGENT_ENTER_TIPS)}`}</div>
    </div>
  );
}));
